let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e1fGs")).then(() => parcelRequire('h03W7'));